/* app/js/src/components/live/createEditLiveFeed/live-feed-create-edit.component.scss */
.cursor-pointer {
  cursor: pointer;
}
.row label {
  color: #7d8fa1;
  text-transform: uppercase;
  margin-right: 5px;
  font-weight: normal;
  font-size: 0.85em;
  min-width: 90px;
  white-space: nowrap;
}
.row input[type=text],
.input-group input[type=text] {
  -webkit-transition: all 0.2s ease;
  transition: all 0.2s ease;
  border-radius: 4px;
  background-color: #ffffff;
  height: 30px;
  border: 1px solid #e1e6eb;
  line-height: 2.2em;
  font-size: 0.9em;
  padding: 0 15px;
  color: #232f3a;
}
.row input[type=text]:focus,
.input-group input[type=text]:focus {
  border: 1px solid #aee5ff;
  outline: none;
}
.row input[type=text]::-webkit-input-placeholder,
.input-group input[type=text]::-webkit-input-placeholder {
  font-weight: 200;
  color: #c9cdd6;
  font-size: 1em;
  letter-spacing: 0.1px;
}
.row input[type=text]:-moz-placeholder,
.input-group input[type=text]:-moz-placeholder {
  font-weight: 200;
  color: #c9cdd6;
  font-size: 1em;
  letter-spacing: 0.1px;
}
.row input[type=text]::-moz-placeholder,
.input-group input[type=text]::-moz-placeholder {
  font-weight: 200;
  color: #c9cdd6;
  font-size: 1em;
  letter-spacing: 0.1px;
}
.row input[type=text]:-ms-input-placeholder,
.input-group input[type=text]:-ms-input-placeholder {
  font-weight: 200;
  color: #c9cdd6;
  font-size: 1em;
  letter-spacing: 0.1px;
}
.row input.ng-invalid.ng-dirty[type=text],
.input-group input.ng-invalid.ng-dirty[type=text],
.row input.ng-invalid.ng-touched[type=text],
.input-group input.ng-invalid.ng-touched[type=text] {
  border-color: #ef5350;
}
.btn-copy,
.btn-export {
  display: inline-block;
  color: #ffffff;
  border-radius: 4px;
  background-color: #232f3a;
  padding: 6px 9px 6px 9px;
  font-size: 0.85em;
  border: 1px solid #879baf;
  cursor: pointer;
  -webkit-transition: all 0.2s ease;
  transition: all 0.2s ease;
}
.btn-copy:focus,
.btn-export:focus {
  outline-color: #ffffff;
}
.btn-copy:hover,
.btn-export:hover {
  background-color: white;
  color: #232f3a;
}
.disabled.btn-copy,
.disabled.btn-export {
  color: #879baf;
  background-color: #dde3e7;
  border-color: #dde3e7;
  cursor: auto;
}
.input-group input[type=checkbox] {
  display: inline-block;
  vertical-align: middle;
  margin: 0;
  margin-right: 13px;
  cursor: pointer;
  position: relative;
}
.input-group input[type=checkbox]:before {
  -webkit-transition: all 0.2s ease;
  transition: all 0.2s ease;
  content: "";
  background-color: #ffffff;
  border: 1px solid #e1e6eb;
  display: inline-block;
  vertical-align: middle;
  width: 10px;
  height: 10px;
  padding: 2px;
  text-align: center;
  position: absolute;
  top: -25%;
}
.input-group input[type=checkbox]:checked:before {
  content: "\f00c";
  font-family: "FontAwesome";
  color: #232f3a;
}
.input-group input[type=checkbox]:focus {
  border: 1px solid #aee5ff;
  outline: none;
}
.cursor-pointer {
  cursor: pointer;
}
.row label {
  color: #7d8fa1;
  text-transform: uppercase;
  margin-right: 5px;
  font-weight: normal;
  font-size: 0.85em;
  min-width: 90px;
  white-space: nowrap;
}
.row input[type=text],
.input-group input[type=text] {
  -webkit-transition: all 0.2s ease;
  transition: all 0.2s ease;
  border-radius: 4px;
  background-color: #ffffff;
  height: 30px;
  border: 1px solid #e1e6eb;
  line-height: 2.2em;
  font-size: 0.9em;
  padding: 0 15px;
  color: #232f3a;
}
.row input[type=text]:focus,
.input-group input[type=text]:focus {
  border: 1px solid #aee5ff;
  outline: none;
}
.row input[type=text]::-webkit-input-placeholder,
.input-group input[type=text]::-webkit-input-placeholder {
  font-weight: 200;
  color: #c9cdd6;
  font-size: 1em;
  letter-spacing: 0.1px;
}
.row input[type=text]:-moz-placeholder,
.input-group input[type=text]:-moz-placeholder {
  font-weight: 200;
  color: #c9cdd6;
  font-size: 1em;
  letter-spacing: 0.1px;
}
.row input[type=text]::-moz-placeholder,
.input-group input[type=text]::-moz-placeholder {
  font-weight: 200;
  color: #c9cdd6;
  font-size: 1em;
  letter-spacing: 0.1px;
}
.row input[type=text]:-ms-input-placeholder,
.input-group input[type=text]:-ms-input-placeholder {
  font-weight: 200;
  color: #c9cdd6;
  font-size: 1em;
  letter-spacing: 0.1px;
}
.row input.ng-invalid.ng-dirty[type=text],
.input-group input.ng-invalid.ng-dirty[type=text],
.row input.ng-invalid.ng-touched[type=text],
.input-group input.ng-invalid.ng-touched[type=text] {
  border-color: #ef5350;
}
.btn-copy,
.btn-export {
  display: inline-block;
  color: #ffffff;
  border-radius: 4px;
  background-color: #232f3a;
  padding: 6px 9px 6px 9px;
  font-size: 0.85em;
  border: 1px solid #879baf;
  cursor: pointer;
  -webkit-transition: all 0.2s ease;
  transition: all 0.2s ease;
}
.btn-copy:focus,
.btn-export:focus {
  outline-color: #ffffff;
}
.btn-copy:hover,
.btn-export:hover {
  background-color: white;
  color: #232f3a;
}
.disabled.btn-copy,
.disabled.btn-export {
  color: #879baf;
  background-color: #dde3e7;
  border-color: #dde3e7;
  cursor: auto;
}
.input-group input[type=checkbox] {
  display: inline-block;
  vertical-align: middle;
  margin: 0;
  margin-right: 13px;
  cursor: pointer;
  position: relative;
}
.input-group input[type=checkbox]:before {
  -webkit-transition: all 0.2s ease;
  transition: all 0.2s ease;
  content: "";
  background-color: #ffffff;
  border: 1px solid #e1e6eb;
  display: inline-block;
  vertical-align: middle;
  width: 10px;
  height: 10px;
  padding: 2px;
  text-align: center;
  position: absolute;
  top: -25%;
}
.input-group input[type=checkbox]:checked:before {
  content: "\f00c";
  font-family: "FontAwesome";
  color: #232f3a;
}
.input-group input[type=checkbox]:focus {
  border: 1px solid #aee5ff;
  outline: none;
}
.input-group {
  font-size: 12px;
  letter-spacing: 0.1px;
  color: #232f3a;
  margin-bottom: 10px;
}
.input-group label {
  display: inline-block;
  margin-right: 13px;
  color: #7d8fa1;
}
.input-group input[type=text] {
  width: 305px;
  border-radius: 4px;
  vertical-align: middle;
}
.input-group:not(:last-child) {
  margin-bottom: 30px;
}
.input-group > * {
  vertical-align: middle;
}
.tasks .task {
  font-style: italic;
  letter-spacing: 0.1px;
  color: #232f3a;
  font-size: 12px;
}
.tasks .task-content {
  font-style: normal;
  margin-top: 14px;
}
:host {
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  flex-direction: column;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  -webkit-flex: 1;
  -ms-flex: 1;
  flex: 1;
}
.header-container {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px 40px;
  border-bottom: solid 2px #879baf;
}
.header-text {
  font-family: "Open Sans";
  font-size: 16px;
  color: #232f3a;
  font-weight: bold;
}
.back-to-scheduler-container {
  display: flex;
  align-items: center;
}
.main-container {
  display: flex;
  flex-direction: column;
  padding-top: 40px;
  padding-left: 60px;
  overflow-y: scroll;
}
.left-side {
  flex-grow: 3;
  display: flex;
  flex-direction: column;
}
.right-side {
  flex-grow: 2;
}
.rounded-btn,
.rounded-btn-prev {
  display: inline-block;
  background: #f1f3f4 no-repeat center;
  width: 28px;
  height: 28px;
  border-radius: 50%;
  cursor: pointer;
}
.rounded-btn-prev {
  background-image: url(/assets/icons/prev.svg);
  margin-right: 10px;
}
.info {
  cursor: pointer;
}
.info-popover {
  background-color: #232f3a;
  max-width: 175px;
  color: white;
  padding: 10px;
}
.info-popover .x-sign {
  direction: rtl;
}
.info-popover .x-sign ::ng-deep svg {
  cursor: pointer;
}
.back {
  line-height: 27px;
}
.small-container {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin-bottom: 24px;
}
.error {
  color: #ef5350 !important;
}
.row {
  display: flex;
  align-items: center;
  margin-bottom: 22px;
}
.row label {
  min-width: auto;
  margin-left: 13px;
}
.row .row-input {
  position: relative;
}
.row .row-input-text {
  display: inline-block;
  top: 100%;
  font-size: 12px;
  font-family: "Open Sans";
  color: #879baf;
}
.row input[type=text] {
  margin-right: 7px;
  width: 10vw;
}
.checkbox-input {
  background-color: #ffffff;
  position: relative;
  display: flex;
}
.checkbox-input div {
  position: relative;
  border: 1px solid #e1e6eb;
  width: 14px;
  height: 14px;
  cursor: pointer;
  margin-top: 6px;
}
.checkbox-input div svg {
  width: 10px;
  height: 7px;
  position: absolute;
  top: -1px;
  bottom: 0;
  left: 0;
  right: 0;
  margin: auto;
  fill-opacity: 0;
}
.checkbox-input span {
  white-space: nowrap;
  padding-left: 10px;
}
.checkbox-input input {
  width: 70px;
}
.checkbox-input input.disabled {
  background-color: #e1e6eb;
}
.checkbox-input .label-black {
  color: #879baf;
  padding-right: 12px;
  font-size: 12px;
}
.checkbox-input.active div svg {
  fill-opacity: 1;
}
.label-subs {
  line-height: 28px;
  font-size: 12px;
  margin-left: 10px;
  padding-top: 6px;
  color: #879baf;
}
.input-group {
  display: flex;
  margin-bottom: 15px;
  align-items: center;
}
.input-group label {
  margin-right: 10px;
  margin-left: 15px;
}
.btn-copy {
  height: 30px;
  background-color: white;
  border: solid 1px #e1e6eb;
  color: #e1e6eb;
  margin: 0 10px 0 5px;
  width: 80px;
  text-align: center;
}
.copy-explain {
  font-family: "Open Sans";
  font-size: 10px;
  color: #7d8fa1;
  visibility: hidden;
}
.clicked {
  visibility: visible;
}
.settingIcon {
  cursor: pointer;
  margin-left: 10px;
  margin-top: 7px;
  flex: 0 0 0 !important;
}
.settingIcon ::ng-deep svg {
  width: 13px;
  height: 13px;
}
.settingIcon ::ng-deep svg path {
  fill: #879baf !important;
}
.encryption-key-error {
  padding-top: 6px;
  margin-left: 8px;
  font-size: 12px;
  font-family: "Open Sans";
  color: #ef5350 !important;
}
.whitelist-ip-chips {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  margin-bottom: 8px;
}
.whitelist-ip-chip {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 4px 8px;
  border: 1px solid #e1e6eb;
  border-radius: 4px;
  background-color: #f1f3f4;
  font-size: 13px;
  color: #232f3a;
  -webkit-user-select: none;
  user-select: none;
}
.whitelist-ip-chip .chip-remove {
  background: transparent;
  border: none;
  cursor: pointer;
  font-size: 16px;
  line-height: 1;
  color: #879baf;
  padding: 0 2px;
}
.whitelist-ip-chip .chip-remove:hover {
  color: #232f3a;
}
.encryption-popover {
  padding: 15px 15px 15px 30px;
  width: 335px;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  border-radius: 4px;
  box-shadow: 0 0 5px 0 rgba(0, 0, 0, 0.2);
  border: solid 1px #e1e6eb;
}
.encryption-popover header {
  margin-bottom: 20px;
  display: flex;
  justify-content: space-between;
}
.submit-container {
  padding: 15px 20px;
  direction: rtl;
}
.footer-container {
  display: flex;
  justify-content: space-between;
}
.btn-black {
  background-color: #232f3a;
  color: #ffffff;
}
.close-btn {
  cursor: pointer;
}
.copied-popover {
  background-color: #232f3a;
  color: #ffffff;
  padding: 5px;
}
.main-container-left-side-header {
  font-family: "Open Sans";
  color: #232f3a;
  font-size: 24px;
  margin-bottom: 30px;
}
.help-block {
  margin-bottom: 20px;
}
.stream-id-prefix {
  font-family: "Open Sans";
  color: #232f3a;
  font-size: 16px;
}
.stream-id-input-container {
  display: inline-block;
  position: relative;
}
.stream-id-input-container .row-input-text {
  position: absolute;
  top: 100%;
}
.metadata-container {
  display: flex;
  justify-content: space-around;
}
.row.az input {
  width: 100px;
}
.columns {
  display: flex;
  width: 100%;
}
.platform-tabs-container {
  display: flex;
  gap: 16px;
  margin: 20px 0 30px;
  border-top: solid 1px #e1e6eb;
  padding-top: 20px;
}
.platform-tabs {
  display: flex;
  flex-direction: column;
  min-width: 180px;
  border-right: solid 1px #e1e6eb;
  padding-right: 8px;
}
.platform-tab {
  font-family: "Open Sans";
  font-size: 13px;
  text-align: left;
  padding: 10px 14px;
  margin-bottom: 4px;
  background: transparent;
  border: 0;
  border-left: solid 3px transparent;
  color: #879baf;
  cursor: pointer;
}
.platform-tab:hover {
  color: #232f3a;
}
.platform-tab.active {
  color: #232f3a;
  font-weight: bold;
  border-left-color: #232f3a;
  background-color: #f1f3f4;
}
.platform-pane {
  flex: 1;
  padding-left: 8px;
  display: flex;
}
.platform-settings {
  flex: 0 0 auto;
}
.platform-preview {
  flex: 0 0 720px;
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin: 0 auto;
}
.streamUrl {
  width: 400px !important;
}
.remoteAddress,
.special-options {
  width: 321px !important;
}
.zixiRemoteName,
.streamName {
  width: 316px !important;
}
.display-inline {
  display: inline-block;
}
.local-port-will-assigned-lbl {
  color: red !important;
}
/*# sourceMappingURL=live-feed-create-edit.component.css.map */
